import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import urlsForHideConnectButton from '~/src/features/_layout/Header/urlsForHideConnectButton';
import { isLeadGenerationHidden, pagesWithHiddenLeadGenerationInHeader } from '~/src/helpers/isLeadGenerationHidden';
import { selectHasAuthorization } from '~/src/store/selectors/auth/selectAccessToken';

/**
 * Хук для определения отображения номера телефона и кнопки подключения в хедере сайта
 */
export const useLeadGeneration = () => {
    const hasAuthorization = useSelector(selectHasAuthorization);
    const { pathname } = useRouter();

    return useMemo(() => {
        // в АЗ нет кнопки подключения, номер телефона отображаем всегда
        if (hasAuthorization) {
            return {
                showPhone: true,
                showButton: false,
            };
        }

        // на страницах, связанных с ПП, всегда скрываем кнопку подключения
        if (urlsForHideConnectButton.includes(pathname)) {
            return {
                showPhone: true,
                showButton: false,
            };
        }

        // скрываем кнопку подключения и номер телефона на определенных страницах в зависимости от аб-теста
        const isLeadGenerationAvailable = !(isLeadGenerationHidden() && pagesWithHiddenLeadGenerationInHeader.includes(pathname));

        return {
            showPhone: isLeadGenerationAvailable,
            showButton: isLeadGenerationAvailable,
        };
    }, [hasAuthorization, pathname]);
};
